import React, { forwardRef, useRef, useEffect } from "react";
import makeStyles from '@mui/styles/makeStyles';
import swal from "sweetalert";
import {
  Grid,
  Checkbox,
  TextField,
  Card,
  CardContent,
  Button,
  ButtonGroup,
} from "@mui/material";

import { ViewList } from "@mui/icons-material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fr, enGB } from "date-fns/locale";
import { DatePicker } from "@mui/x-date-pickers";

import { useTranslation } from "react-i18next";
/* import { Button } from "reactstrap"; */
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../../../actions/api";
import ProductSelectInPrescriptionModal from "../../../services/ExternalApiLogModal";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";
import Autocomplete from '@mui/material/Autocomplete';

import { getAllFacilityList } from "../../../services/Common";

import { format, subDays } from 'date-fns';
import encryptionService from "../../../services/encryptionService";
const ExternalAPIDataTransferLog = (props) => {
  const tblMenuRefHolder = useRef({ table: null });
  const tblMenuRef = tblMenuRefHolder.current;
  const { useState } = React;
  const { t, i18n } = useTranslation();
  const queryClient = useQueryClient();
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const FacilityId = localStorage.getItem("FacilityId");
  const lan = localStorage.getItem("LangCode");
  const menukey = "external-api-data-transfer-log";
  const UserInfo = encryptionService.decryptUserInfo();


  const [currFacilityId, setCurrFacilityId] = useState(0);
  const [currrptGroupBy, setCurrrptGroupBy] = useState(1);

  const UserRole = ""; // UserInfo == 0 ? "" : UserInfo[0].RoleId;

  const classes = useStyles();
  const tableRef = useRef();

  const [dataItems, setDataItems] = useState([]);
  const [selectedRoleData, setSelectedRole] = useState(0);
  const [isLoadingll, setLoading] = useState(true);

  const [currRowId, setCurrRowId] = useState(0);
  const [openSqlLog, setopenSqlLog] = useState(false);

  const [LogDataArray, setLogDataArray] = useState([]);

  const [LOGSuccessButton, setLOGSuccessButton] = useState(true);
  const [LOGErrorButton, setLOGErrorButton] = useState(false);

  const handleClose = (modalname) => {
    switch (modalname) {
      case "ProductBatch":
        setopenSqlLog(false);
        break;
      case "ProductBatchOpen":
        setopenSqlLog(true);
        break;

      default:
        break;
    }
  };

  const [selectedStartDate, setSelectedStartDate] = React.useState(
    format(subDays(new Date(), 7), 'yyyy-MM-dd')
  );

  const handleStartDateChange = (date) => {
    setSelectedStartDate(date);
    setLoading(true);
    setSelectedRole(0);
  };

  const [selectedEndDate, setSelectedEndDate] = React.useState(
    format(new Date(), 'yyyy-MM-dd')
  );

  const handleEndDateChange = (date) => {
    setSelectedEndDate(date);
    setLoading(true);
    setSelectedRole(0);
  };

  let params0 = {
    menukey: menukey,
    action: "getDataList",
    logStartDate: selectedStartDate,
    logEndDate: selectedEndDate,
    rptGroupBy: currrptGroupBy,
    page_limit: JSON.stringify(100),
    page_number: JSON.stringify(0 + 1),
    search_key: "",
    // FacilityId:currFacilityId
  };

  const { isLoading, error, isError, data, refetch } = useQuery(
    [params0],
    api.getExternalAPIDataTransferLogData,
    {
      onSuccess: (data) => {
        setDataItems(data);

        //setSelectedrow(true);
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0, //1000 * 60 * 60 * 24,
    }
  );


  const rowClick = (e: any, row: any) => {
    let rowData = row._row.data;
    console.log(rowData.id);
    setSelectedRole(rowData.id);
    //MenuRefetch();
  };

  useEffect(() => {
    //handleClose("ProductBatchOpen");
  }, [LogDataArray]);

  useEffect(() => {
    console.log("useEffect calling for refresh");
    if (selectedRoleData > 0) {
      /* MenuRefetch(); */
    }
  }, [selectedRoleData]);

  const columns = [
    { title: "Id", field: "id", width: 50, visible: false },
    {
      title: t(DispensingLanguage[lan][menukey]["SL."]),
      formatter: "rownum",
      width: 60,
      hozAlign: "center",
      headerSort: false,
      headerHozAlign: "center",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Log Date"]),
      field: "LogDate",
      headerFilter: true,
      width: 132,
    },

    {
      title: t(DispensingLanguage[lan][menukey]["API URL"]),
      field: "apiURL",
      headerFilter: true,
      width: 200,
    },
    /* {
      title: t(DispensingLanguage[lan][menukey]["Log Message"]),
      field: "LogMessage",
      headerFilter: true,
     
    }, */

    {
      title: t(DispensingLanguage[lan][menukey]["Log Message"]),
      field: "LogMessage",
      headerFilter: true,
      formatter: function (cell, formatterParams, onRendered) {
        var row = cell.getRow().getData();
        var logMessage = JSON.parse(row.LogMessage).message;
        return logMessage;
      },
      hozAlign: "left",
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Details"]),
      headerSort: false,
      field: "custom",
      hozAlign: "center",
      width: 60,
      formatter: reactFormatter(<ShowSqlLogPopup />),
    },
  ];


  function ShowSqlLogPopup(props: any) {
    const rowData = props.cell._cell.row.data;

    return (
      <>
        <ViewList
          onClick={() => {
            setCurrRowId(rowData.id);
            setLogDataArray([rowData.InputLOG, rowData.LogMessage]);
            //console.log("gggggggggggggg",rowData);
            handleClose("ProductBatchOpen");
          }}
        />
      </>
    );
  }

  const handleOnClickForButton = (type) => {
    if (type == "LOG_Success") {
      setLOGSuccessButton(true);
      setLOGErrorButton(false);
      setCurrrptGroupBy(1);
    } else if (type == "LOG_Error") {
      setLOGSuccessButton(false);
      setLOGErrorButton(true);
      setCurrrptGroupBy(2);
    }
  };

  return (
    <>
      <div className={classes.dispenserPageTitle}>
        <div className="d-flex justify-dispenser mb-2">
          <Grid container>
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading">
              <div className="sw_heading_title">
                {" "}
                {
                  DispensingLanguage[lan][menukey][
                    "External API Data Transfer Log"
                  ]
                }
              </div>
            </div>
          </Grid>
          </Grid>
        </div>

        <ProductSelectInPrescriptionModal
          handleClose={handleClose}
          open={openSqlLog}
          LogDataArray={LogDataArray}
          {...props}
        />

        {/* start of filter */}
        <Card className="sw_card sw_filter_card">
          <CardContent className="sw_filterCardContent">
            <Grid container spacing={1}>
              <Grid item xs={1} sm={2}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                  <Grid container justifyContent="space-around">
                                        <DatePicker
                        inputFormat="dd/MM/yyyy"
                        label={DispensingLanguage[lan][menukey]["Log Start Date"]}
                        value={selectedStartDate}
                        onChange={handleStartDateChange}
                                            renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          className={classes.fullWidth}
                        />
                      )}
                    />
                  </Grid>
                </LocalizationProvider>
              </Grid>

              <Grid item xs={1} sm={2}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                  <Grid container justifyContent="space-around">
                                        <DatePicker
                        inputFormat="dd/MM/yyyy"
                        label={DispensingLanguage[lan][menukey]["Log End Date"]}
                        value={selectedEndDate}
                        onChange={handleEndDateChange}
                                            renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          className={classes.fullWidth}
                        />
                      )}
                    />
                  </Grid>
                </LocalizationProvider>
              </Grid>

              <Grid item xs={1} sm={1}> </Grid>
              <Grid item xs={4} sm={4}>
                <ButtonGroup
                  variant="outlined"
                  aria-label="outlined button group"
                >
                  <Button
                    className={LOGSuccessButton ? "active" : ""}
                    onClick={() => handleOnClickForButton("LOG_Success")}
                  >
                    {DispensingLanguage[lan][menukey]["Success"]}
                  </Button>
                  <Button
                    className={LOGErrorButton ? "active" : ""}
                    onClick={() => handleOnClickForButton("LOG_Error")}
                  >
                    {DispensingLanguage[lan][menukey]["Errors"]}
                  </Button>
                </ButtonGroup>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        {/* end of filter */}

        <Grid item xs={12} sm={12}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
              <div className="sw_relative">
                <div className="uniqueName">
                  <ReactTabulator
                    onRef={(r) => { tblMenuRef.table = r.current; }}
                    options={{
                      selectableRows: 1,
                      selectableRowsRangeMode: "click",
                    }}
                    columns={columns}
                    data={dataItems}
                    layout={"fitColumns"}
                    height={"500px"}
                    // tooltips={true}
                    // dataTree={true}

                    // rowClick={(e, row) => rowClick(e, row)}
                        events={{
                rowClick: (e, row) => rowClick(e, row),
              }}
                  />
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default ExternalAPIDataTransferLog;

const useStyles = makeStyles({
  dispenserPageTitle: {
    marginTop: "60px",
    color: "white",
    background: "whitesmoke",
    color: "black",
    borderRadius: "10px",
    padding: "1rem",
  },
  tableContainer: { backgroundColor: "whitesmoke", borderRadius: "10px" },
  fullWidth: {
    width: "95%",
  },
  filterDiv: {
    width: "80%",
    display: "flex",
  },
});
